import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useLocalStorage } from '@makeably/creativex-design-system';
import ExplorerSearch from 'components/internal/explorer/ExplorerSearch';
import { isDefined } from 'utilities/item';
import { internalExplorerHomePath } from 'utilities/routes';

const propTypes = {
  searchBy: PropTypes.string,
};

const defaultProps = {
  searchBy: undefined,
};

function ExplorerWidget({
  searchBy: initialSearchBy,
}) {
  const [search, setSearch] = useState('');
  const [searchBy, setSearchBy] = useLocalStorage('cxIntExplorerSearchBy', initialSearchBy);
  const useSearchBy = !isDefined(initialSearchBy);

  const handleSearch = () => {
    window.location.href = internalExplorerHomePath({
      input: search,
      search_by: searchBy,
    });
  };

  return (
    <div>
      <ExplorerSearch
        search={search}
        searchBy={searchBy}
        onSearch={handleSearch}
        onSearchByChange={useSearchBy ? setSearchBy : null}
        onSearchChange={setSearch}
      />
    </div>
  );
}

ExplorerWidget.propTypes = propTypes;
ExplorerWidget.defaultProps = defaultProps;

export default ExplorerWidget;
